module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/geom/Rectangle","root":["openfl","geom","Rectangle"],"commonjs":"openfl/geom/Rectangle","commonjs2":"openfl/geom/Rectangle"}
// module id = 13
// module chunks = 0